import React from 'react';
import {Stack, Typography, Button} from '@lapilli-ui/components';

const PopularSearches = ({title, searches, onClick}) => {
    const handleClick = (event) =>{
      event.stopPropagation();
        onClick(event.target.id);
    }
    return (
        <Stack className='ywcas-popular-searches-wrapper'>
            <Typography className='ywcas-popular-searches__title'>
                {title}
            </Typography>
            {searches && (
                <Stack className='ywcas-popular-searches-items' direction='row' sx={{'flexWrap':'wrap'}} spacing={1}>
                {
                    searches.map(search =>
                        <Button className='ywcas-popular-searches-item' key={search} id={search} onClick={handleClick} size='md' variant='outlined'>
                            {search}
                        </Button>
                    )
                }
            </Stack>
            )
            }
        </Stack>
    )
}

export default PopularSearches;